import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, ConfirmationDialog } from 'components/Elements';
import { LockClosedIcon } from '@heroicons/react/solid';

export const RequestAccess = ({ resource = 'this feature' }) => {
  const [feedback, setFeedback] = useState('');

  const handleFakeRequest = () => {
    setFeedback(
      '🚧 Access request sent (just kidding). This feature isn’t wired up in production yet. Check back soon!'
    );
    setTimeout(() => setFeedback(''), 6000); // Auto-clear after 6s
  };

  return (
    <ConfirmationDialog
      icon="info"
      title="Request Access"
      body={`You currently don’t have permission to view ${resource}. Would you like to request access?`}
      triggerButton={
        <Button
          variant="glass"
          startIcon={<LockClosedIcon className="w-4 h-4" />}
          size="sm"
          className="text-white/80"
        >
          Request Access
        </Button>
      }
      confirmButton={
        <Button
          type="button"
          variant="darkGlass"
          onClick={handleFakeRequest}
        >
          Send Request
        </Button>
      }
    >
      {feedback && (
        <div className="mt-4 p-3 rounded-md bg-white/10 text-sm text-white/70 border border-white/10 shadow-inner">
          {feedback}
        </div>
      )}
    </ConfirmationDialog>
  );
};

RequestAccess.propTypes = {
  resource: PropTypes.string,
};
